<template>
  <div class="accManager-cla">
    <div class="tab-cla">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$t('accManager.doorList')" name="doorList"></el-tab-pane>
        <el-tab-pane :label="$t('accManager.timeSlot')" name="timeSlot"></el-tab-pane>
        <el-tab-pane :label="$t('accManager.permissionGroup')" name="permissionGroup"></el-tab-pane>
      </el-tabs>
    </div>
    <div>
      <doorList v-if="activeName === 'doorList'"></doorList>
      <timeSlot v-if="activeName === 'timeSlot'"></timeSlot>
      <permissionGroup v-if="activeName === 'permissionGroup'"></permissionGroup>
    </div>
  </div>
</template>

<script>

import doorList from './accManager/doorList'
import timeSlot from './accManager/timeSlot'
import permissionGroup from './accManager/permissionGroup'
export default {
  components: {
    doorList,
    timeSlot,
    permissionGroup
  },
  data() {
    return {
      activeName: 'doorList'
    }
  },
  methods: {},
  mounted() {}
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
.accManager-cla {
  .header_tool_cla {
    /deep/ .el-tabs__header {
      margin: 0 0 3px 0;
    }
  }
  .black_panel_cla {
    min-height: 500px;
  }
  /deep/.el-tabs__nav-wrap {
    &::after {
      display: none;
    }
  }
  .tab-cla {
    position: relative;
    height: 40px;
    line-height: 40px;
    background: #fff;
    border-radius: 2px;
    padding: 10px;
  }

  .top-tab-cla {
    padding: 5px 15px;
    line-height: 1.5;
    cursor: pointer;
  }
  .checked {
    color: @themeColor;
    border-bottom: 2px solid;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/accManager/accManager.vue